import { render, staticRenderFns } from "./ProfileFrontend.vue?vue&type=template&id=4a8aacd5&"
import script from "./ProfileFrontend.vue?vue&type=script&lang=js&"
export * from "./ProfileFrontend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports